const chunk = (arr, size) => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  );
};

const columnChunkId = (columnId, index) => {
  const columnSuffix = index === 0 ? '' : `--${index + 1}`;
  return `${columnId}${columnSuffix}`;
};

export { chunk, columnChunkId };
